<template>
  <div class="accidentRescueEdit">
    <div class="center">
      <div class="title"><span class="star">*</span>请选择产品分类</div>
      <div class="category">
        <div
          class="categoryBtn"
          :class="{active: item.check}"
          v-for="(item, index) in categoryList"
          :key="index"
          @click="getProduct(item)"
        >
          {{ item.categoryName }}
        </div>
      </div>
    </div>
    <div class="center">
      <div class="title"><span class="star">*</span>请选择服务类型</div>
      <div class="category">
        <div
          class="categoryBtn"
          :class="{active: item.check}"
          v-for="(item, index) in productList"
          :key="index"
          @click="checkProduct(item)"
        >
          {{ item.productSkuName }}
        </div>
      </div>
    </div>
    <div class="bottom">
      <van-button
        class="submit"
        :disabled="isDisabled"
        type="info"
        @click="submit"
      >下一步</van-button>
    </div>
  </div>
</template>
<script>
import { getProductListByCategoryCode } from '@/common/api.js';
import { cookieGet } from '@/common/cookie';
export default {
  data() {
    return {
      categoryList: [
        {
          categoryName: '事故拖车',
          categoryCode: 'FL90000002',
          check: false
        }, {
          categoryName: '事故困境',
          categoryCode: 'FL90000003',
          check: false
        }
      ],
      productList: [],
      productCode: '',
      skuCode: ''
    };
  },

  computed: {
    isDisabled() {
      return !this.skuCode;
    }
  },
  methods: {
    async getProduct(data) {
      this.categoryList && this.categoryList.forEach(item => {
        item.check = false;
        if (item.categoryCode === data.categoryCode) {
          item.check = true;
        }
      });
      try {
        const res = await getProductListByCategoryCode({ categoryCode: data.categoryCode, channelCode: cookieGet('channelCompanyCode') });
        if (res) {
          console.log(res, '--');
          this.productList = [];
          res && res.forEach(items => {
            this.productList = [...this.productList, ...items.productStandardSkuRespVoList];
          });
          this.productList && this.productList.forEach(itemsub => {
            this.$set(itemsub, 'check', false);
          });
          console.log(this.productList, 'this.productList');
        }
      } catch (error) {
        console.log(error);
      }
    },
    checkProduct(data) {
      this.productList && this.productList.forEach(item => {
        item.check = false;
        if (item.productSkuCode === data.productSkuCode) {
          item.check = true;
        }
      });
      this.productCode = data.productCode;
      this.skuCode = data.productSkuCode;
    },
    submit() {
      this.$router.push({
        path: '/accidentRescue/add',
        query: {
          productCode: this.productCode,
          skuCode: this.skuCode
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.accidentRescueEdit{
  font-size: 0.32rem;
  padding: 0.3rem 0 1.2rem;
  height: 100vh;
  background: #F2F3F5;
  box-sizing: border-box;
  .center{
    width: 94vw;
    background: #fff;
    border-radius: 0.2rem;
    margin: 0 auto 0.3rem;
    padding: 0.3rem;
    box-sizing: border-box;
    .title{
      font-size: 0.30rem;
      color: #787878;
      .star{
        color: #F32222;
      }
    }
  }
  .category{
    display: flex;
    flex-wrap: wrap;
    font-size: 0.3rem;
    .categoryBtn{
      margin-right: 0.3rem;
      margin-top: 0.3rem;
      background: #E1E7ED;
      color: #646464;
      border-radius: 0.08rem;
      padding: 0.2rem 0.5rem;
    }
    .active{
      background: #3399FF;
      color: #fff;
    }
  }
  .bottom{
    width: 100vw;
    height: 1.2rem;
    box-shadow: 0 0 0.08rem 0 rgba(0,0,0,0.2);
    background: #fff;
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    .submit{
      width: 90vw;
      height: 0.8rem;
      border-radius: 0.15rem;
    }
  }
}
</style>
